import Linkable from 'component/LinkableComponent/linkable-component'
import { FormattedMessage } from 'react-intl'
import ChevronIcon from 'svg-icons/chevron-icon'

function MainButton({className = null , link , isInternal = true , text, ...reset}) {
  return (
    <Linkable className={`main-btn ${className}`} link={link} isInternal={isInternal} {...reset}>
        <span>
            <FormattedMessage id={text} />
        </span>
        <ChevronIcon width={12} height={12} color="#FFFFFF" />
    </Linkable>
  )
}

export default MainButton